export default __webpack_public_path__ + "static/media/history.a07625b5.svg";